import {Pipe, PipeTransform} from '@angular/core';
import SectionsAccess from 'src/app/permission/enums/sectionsAccess.enum';

@Pipe({name: 'sections'})
export class SectionsPipe implements PipeTransform {

  transform(value: SectionsAccess, place: 'table' | 'pipe' = 'table'): string {
    if (SectionsAccess.isOn(value, SectionsAccess.All)){
        return SectionsAccess.toString(SectionsAccess.All);
    }
    const sections = SectionsAccess.convertToListString(value, false);
    if (place === 'table'){
      if (sections.length === 0) {
        return SectionsAccess.toString(SectionsAccess.None);
      } else if (sections.length === 1) {
        return sections[0];
      } else if (sections.length === 2) {
        return `${sections[0]} (+1 other)`;
      } else {
        return `${sections[0]} (+${sections.length - 1} others)`;
      }
    }
    else if (place === 'pipe'){
        return sections.join(', ');
    }
    else{
        return '';
    }
  }
}
